import { createElementBlock as t, openBlock as e, createElementVNode as l } from "vue";
import r from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(a, o, p, m, f, i) {
  return e(), t("svg", s, o[0] || (o[0] = [
    l("path", {
      fill: "currentColor",
      d: "m8.446 7.397.084.073L12 10.939l3.47-3.47a.75.75 0 0 1 1.133.977l-.073.084L13.061 12l3.47 3.47a.75.75 0 0 1-.977 1.133l-.084-.073L12 13.061l-3.47 3.47a.75.75 0 0 1-1.133-.977l.073-.084L10.939 12l-3.47-3.47a.75.75 0 0 1 .977-1.133Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(n, [["render", c]]);
export {
  u as default
};
